import antdPtBR from 'antd/es/locale/pt_BR'
import antdEnUS from 'antd/es/locale/en_US'
import pt from './locales/pt_BR.json'
import en from './locales/en_US.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { THEME_CONFIG } from 'configs/AppConfig'
import Utils from 'utils'

export const resources = {
  pt: {
    translation: pt,
    antd: antdPtBR,
  },
  en: {
    translation: en,
    antd: antdEnUS,
  },
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: THEME_CONFIG.locale,
  lng: THEME_CONFIG.locale,
  interpolation: {
    escapeValue: false,
  },
})

const t = key => {
  const traslatedKey = Utils.getTranslationKey(key)
  // console.log(traslatedKey)
  return i18n.t(traslatedKey)
}

const appI18n = { t }

export default appI18n
